export interface OutreachEntity<T = OutreachEntityType> {
    id: number;
    type: T;
    link: string;
    title: string;
    description?: string;
    shortDescription?: string;
    image?: string;
    place?: string;
    date: string;
    dateEnd?: string;
    isPinned: boolean;
}

export type Event = OutreachEntity<OutreachEntityType.event>;
export type Project = OutreachEntity<OutreachEntityType.project>;
export type Dataset = OutreachEntity<OutreachEntityType.dataset>;

export enum OutreachEntityType {
    event = 'event',
    project = 'project',
    dataset = 'dataset'
}
